import { Component, OnInit, NgZone, } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { AuthservicesService } from '../../../../services/authservices.service';
import { typeWithParameters } from '@angular/compiler/src/render3/util';
import { Router } from '@angular/router';
@Component({
  selector: 'app-social-links',
  templateUrl: './social-links.component.html',
  styleUrls: ['./social-links.component.css']
})
export class SocialLinksComponent implements OnInit {
  form: FormGroup;
  socialLinks: FormArray;
  submitted = false;
  errorMessage;
  tags;
  tagid;
  communityData;
  currentUser;

  constructor(
    private authService: AuthservicesService,
    private fb: FormBuilder,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('ministry_currentUser'));
    this.getCommunityId(this.currentUser);
    this.addsocialLinks();
    this.errorMessage = environment.errorMessage;
    this.form = this.fb.group({
      socialLinks: this.fb.array([this.createItem()])
    });
  }

  get f() {
    return this.form.controls;
  }

  // Custom validator for URL protocol
  urlProtocolValidator(control) {
    const urlPattern = /^https?:\/\//;
    if (control.value && !urlPattern.test(control.value)) {
      return { invalidProtocol: true };
    }
    return null;
  }

  createItem() {
    return this.fb.group({
      tag: ['', Validators.required],
      title: ['', Validators.required],
      link: ['', [Validators.required, this.urlProtocolValidator]]
    });
  }

  addsocialLinks() {
    this.authService.addSocialLinks().subscribe(
      (res: any) => {
        console.log(res);
        this.tags = res.data;
      },
      error => {
        console.log(error);
      }
    );
  }

  addArr() {
    this.socialLinks = this.form.get('socialLinks') as FormArray;
    this.socialLinks.push(this.createItem());
  }

  removeAddress(i) {
    this.socialLinks = this.form.get('socialLinks') as FormArray;
    this.socialLinks.removeAt(i);
  }

  changeTags(event) {
    this.socialLinks = this.form.get('socialLinks') as FormArray;

    this.tags.forEach(e => {
      if (e['name'] === event.target.value) {
        this.tagid = e._id;
      }
    });
    if (this.tagid)
      this.socialLinks['controls'].forEach((e) => {
        e.get('tag').setValue(this.tagid);
      });
  }

  fetchData() {
    if (this.communityData.socialLinks.length != 0) {
      this.socialLinks = this.form.get('socialLinks') as FormArray;
      for (let i = 0; i < this.communityData['socialLinks'].length; i++) {
        let obj = {
          tag: this.communityData['socialLinks'][i].tag._id,
          title: this.communityData['socialLinks'][i].title,
          link: this.communityData['socialLinks'][i].link
        };
        this.socialLinks.push(
          this.fb.group({
            tag: obj.tag,
            title: obj.title,
            link: obj.link
          })
        );
      }
      this.socialLinks.removeAt(0);
    }
  }

  getCommunityId(data) {
    let id;
    if (data) {
      id = this.currentUser.id;
    }
    this.authService.getCommunityByid(id).subscribe(
      (res: any) => {
        this.communityData = res.data;
        this.fetchData();
      },
      error => {
        console.log(error);
      }
    );
  }

  redirect() {
    this.router.navigate(['/user-registration/address']);
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }

    this.authService.signUpSocialLinks(this.form.value).subscribe(
      (res: any) => {
        this.authService.successMessage('Social links has been added successfully', 'success');
        this.router.navigate(['/user-registration/about-us']);
      },
      error => {
        if (error.error.code == '401') {
          this.authService.refreshToken();
        }
        this.authService.successMessage(error.error.message, 'error');
        console.log(error);
      }
    );
  }
}
